<template>
  <div class="searchAreaStyle d-flex align-center">
    <div v-if="isEdit" class="pl-16">
      {{ target }}
    </div>
    <span v-else class="d-flex align-center">
      <div class="yCenter original-selectbox selectBoxStyle pl-10">
        <div class="titleStyle font-weight-bold pr-5">
          {{
            $t('stock-adjust.stock-adjust_stock-adjust_adjustment-warehouse')
          }}
        </div>
        <div class="combobox">
          <NormalCombobox
            v-model="selectClientName.storage"
            :items="selectBoxInfo.clientNameList"
            height="32px"
          />
        </div>
      </div>

      <NormalButton
        :text="$t('sale.sale_select-pecipient-button')"
        height="32px"
        width="120px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="recipientSearch"
        class="mr-8"
      />
      <StorageRecipientSearchDialog
        v-model="dialog.recipientSearch"
        :selectClientName="selectClientName.storage"
        :target="selectBoxInfo.target.common"
        :comboboxList="selectBoxInfo.clientNameList"
        :tableData="history"
        @reflect="reflect"
      />

      <NormalButton
        :text="$t('common.common_csv-download')"
        height="32px"
        width="120px"
        color="white"
        textColor="thinText--text"
        :outlined="true"
        @click="csvDownload"
        class="mr-4"
      />
      <label class="fileInputLabel">
        {{ $t('common.common_csv-import') }}
        <input
          ref="file"
          type="file"
          accept=".csv"
          class="fileInput"
          @change="fileSelected"
        />
      </label>
      <a
        class="linkText--text csvLinkStyle csvSampleStyle font-weight-bold"
        :href="csvSampleUrl"
        target="_blank"
      >
        {{ '※' + $t('common.common_csv-sample') }}
      </a>
    </span>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { storageUtil } from '@/util'
import { NormalButton, NormalCombobox } from '@/components/items'

import StorageRecipientSearchDialog from '@/components/layouts/Dialogs/StorageRecipientSearchDialog'
import IncompleteNotificationHistoryTable from '@/components/items/Tables/IncompleteNotificationHistoryTable';

export default {
  components: {
    NormalButton,
    NormalCombobox,
    StorageRecipientSearchDialog
  },
  props: {
    target: { default: '' }
  },
  data: () => ({
    isEdit: false,

    selectClientName: {
      storage: {
        label: '',
        value: null
      }
    },
    historySelectData: {
      selectClientName: {
        label: '',
        value: null
      },
      radioGroup: ''
    },
    selectBoxInfo: {
      target: {
        ship: 'ship.ship_ship',
        loading: 'loading.loading_loading',
        common: 'common.common_storage'
      },
      clientId: 'storageRecipientId',
      clientNameList: []
    },
    inputData: {
      uploadFile: '',
      platform: {}
    },
    history: {
      headers: [
        {
          value: 'radioBtn',
          width: '55px',
          filterable: false,
          sortable: false,
          align: 'center'
        },
        {
          value: 'storageRecipientId',
          align: ' d-none'
        },
        {
          text: 'product.product_recipient-name',
          value: 'name',
          width: '109px',
          filterable: false,
          sortable: false,
          align: 'center'
        },
        {
          text: 'product.product_recipient-address',
          value: 'address',
          width: '249px',
          filterable: false,
          sortable: false,
          align: 'center'
        },
        {
          text: 'product.product_recipient-tel',
          value: 'phoneNumber',
          width: '159px',
          filterable: false,
          sortable: false,
          align: 'center'
        },
        {
          text: 'product.product_recipient-memo',
          value: 'note',
          width: '224px',
          filterable: false,
          sortable: false,
          align: 'center'
        }
      ],
      itemKey: 'storageRecipientId',
      items: []
    },
    dialog: {
      recipientSearch: false
    }
  }),
  async created() {
    await this.init(false)
  },

  methods: {
    ...mapActions('Storage', [
      'getStorageListFromApi',
      'getStockAdjustProductListCsv'
    ]),
    ...mapGetters('Storage', [
      'getStorageListFromState',
      'getStockAdjustProductListCsvFromState'
    ]),
    ...mapActions('Common', ['setIsLoading']),

    async init() {
      const isHideUnusedStorage = true
      const storageList = await storageUtil.getStorageIdNameList(
        isHideUnusedStorage
      )
      this.selectBoxInfo.clientNameList = storageList.data
    },

    async recipientSearch() {
      const target = this.selectBoxInfo.target
      if (!this.selectClientName.storage.value) {
        alert(this.$t(target.common) + this.$t('common.common_input-select'))
        return
      }

      await Promise.all([this.getStorageListFromApi()]).then((message) => {
        const targetStorage = this.getStorageListFromState().find(
          (ele) => ele.storageId === this.selectClientName.storage.value
        )

        this.history.items = targetStorage.storageRecipients
        this.dialog.recipientSearch = true
      })
    },

    async csvDownload() {
      if (this.selectClientName.storage.value !== null) {
        alert(`ご注意ください！
商品番号が数値のみで登録されている場合、文字列変換せずCSVからエクセル形式に保存すると誤表記されます。`)
        this.setIsLoading(true)
        if (
          await this.getStockAdjustProductListCsv({
            adjustStorageId: this.selectClientName.storage.value
          })
        ) {
          const response = this.getStockAdjustProductListCsvFromState()
          alert(this.$t('common.common_sent-mail'))
        } else {
          alert(this.$t('common.error_unexpected-error-occured'))
        }
        this.setIsLoading(false)
      } else {
        alert(this.$t('common.common_select-storage'))
      }
    },

    reflect(...args) {
      const [radioGroup] = args
      const storageRecipient = this.history.items.find(
        (ele) => ele[this.history.itemKey] === radioGroup
      )
      this.$emit('selectStorageRecipient', storageRecipient)
    },

    fileSelected(event) {
      const file = event.target.files[0]
      // ファイル存在チェック
      if (file) {
        // CSVファイル以外の場合は処理中断
        if (!file.name.match('.(csv)$')) {
          alert('拡張子が.csv以外のファイルはアップロードできません。')
          this.$refs.file.value = '' // 初期化
          return // 処理を中断
        }
      }
      const reader = new FileReader()

      const tmpArray = []

      const adjustData = []
      const adjustDataForShip = []
      const errorFlg = []

      const loadFunc = () => {
        const lines = reader.result.split('\n')

        // 配列の先頭行（ヘッダー）要素を削除
        lines.shift()

        // 配列の末尾行要素を削除
        lines.pop()

        lines.forEach((element, index) => {
          const csvPrevColumns = index > 0 ? lines[index - 1].split(',') : []
          const csvColumns = element.split(',')

          // 前の行と商品マスタIDが異なる場合→配列に要素追加
          if (csvColumns[4] !== csvPrevColumns[4]) {
            tmpArray.push([csvColumns])
          }
          // 前の行と商品マスタIDが同じな場合→直前の配列を更新
          else {
            tmpArray.slice(-1)[0].push(csvColumns)
          }
        })
        const isPlusQuantity = (currentValue) => currentValue >= 0
        const isMinusQuantity = (currentValue) => currentValue <= 0

        tmpArray.forEach((ele1, index) => {
          const quantities = ele1.map((item) => item[6])

          quantities.reduce((prev, current) => {
            if (Math.sign(Number(prev) !== Math.sign(Number(current)))) {
              return
            }
          }, 0)

          let plusCount = 0
          let zeroCount = 0
          let minusCount = 0
          quantities.forEach((ele, index) => {
            if (Number(ele) > 0) {
              plusCount++
            } else if (Number(ele) < 0) {
              minusCount++
            } else if (Number(ele) === 0) {
              zeroCount++
            } else {
              return
            }
          })
          if (plusCount > 0 && minusCount > 0) {
            errorFlg.push({
              message: '同一商品IDで入庫数／出庫数の値にプラスとマイナスの両方が存在します。'
            })
          }

          // 調整数量がすべて0以上なら入庫調整
          if (quantities.every(isPlusQuantity)) {
            const productCurrency = {
              label: '',
              value: Number(ele1[0][9])
            }
            const productExpiredDate = ele1[0][8]
            const productId = Number(ele1[0][4])
            const productLotNumber = ele1[0][7]
            const productMoveId = 0
            const productPrice = ele1[0][10].replace('\r', '')
            const rackInfoLists = []
            ele1.forEach((ele2, index) => {
              const rackInfoList = {
                quantity: Number(ele2[6]),
                rackNumber: ele2[5]
              }
              rackInfoLists.push(rackInfoList)
            })
            const rackNumberList = [ele1[0][5]]

            adjustData.push({
              productCurrency: productCurrency,
              productExpiredDate: productExpiredDate,
              productId: productId,
              productLotNumber: productLotNumber,
              productMoveId: productMoveId,
              productPrice: productPrice,
              rackInfoList: rackInfoLists,
              rackNumberList: rackNumberList
            })
          }
          // 調整数量がすべて0以下なら出庫調整
          else if (quantities.every(isMinusQuantity)) {
            const notYet = String(
              quantities.reduce(
                (prev, current) => Number(prev) + Number(current),
                0
              )
            )
            const product = Object()
            const productExpiredDate = ''
            const productId = Number(ele1[0][4])
            const productLotNumber = ''
            const productMoveId = 1
            const quantity = Math.abs(
              quantities.reduce(
                (prev, current) => Number(prev) + Number(current),
                0
              )
            )
            const rackInfoLists = []
            const rackNumberLists = []
            ele1.forEach((ele2, index) => {
              const rackNumberList = {
                count: String(Math.abs(Number(ele2[6]))),
                quantity: 0, //toDO
                rackNumber: ele2[5]
              }
              rackNumberLists.push(rackNumberList)
            })
            adjustDataForShip.push({
              notYet: notYet,
              product: product,
              productExpiredDate: productExpiredDate,
              productId: productId,
              productLotNumber: productLotNumber,
              productMoveId: productMoveId,
              quantity: quantity,
              rackInfoList: rackInfoLists,
              rackNumberList: rackNumberLists
            })
          }
        })

        //this.errorFlg.push(errorFlg)
        this.tmpArray = tmpArray
        this.adjustData = adjustData
        this.adjustDataForShip = adjustDataForShip
      }

      reader.readAsText(file)

      // onloadはreadAsBinaryStringでファイルを読み込んだ後に実行されます.
      reader.onload = loadFunc

      if (errorFlg.length > 0) {
        alert(Array(errorFlg).join('\n'))
        this.$refs.file.value = '' // 初期化
        return
      }

      this.$refs.file.value = '' // 初期化
      this.$emit('parent-event', adjustData, adjustDataForShip)
    }
  },
  computed: {
    csvSampleUrl() {
      let url = ''
      switch (process.env.VUE_APP_ENV_NAME) {
        // TODO S3にテンプレートをアップロード後にリンク置き換え
        case 'production':
          url =
            'https://order-assets.spe-s.com/sample/master-upload/bulk_stock_adjust_sample_20241017.zip'
          break
        case 'staging':
          url =
            'https://stg-order-assets.spe-s.com/sample/master-upload/bulk_stock_adjust_sample_20241017.zip'
          break
        default:
          url =
            'https://dev-order-assets.spe-s.com/sample/master-upload/bulk_stock_adjust_sample_20241017.zip'
      }
      return url
    }
  },
  watch: {
    selectClientName: {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('change', newVal)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.searchAreaStyle {
  height: 70px;

  .titleStyle {
    font-size: 18px;
  }

  .combobox {
    width: 194px;
  }

  .selectBoxStyle {
    width: 350px;
    // margin: 0px 16px 0px 63px !important;
  }

  .textButtonStyle {
    margin: 0px 21px;
  }

  .fileInput {
    display: none;
  }
  .fileInputLabel {
    width: 128px;
    height: 32px;
    text-align: center;
    margin: 0px 12px 0px 0px;
    padding: 7px 9px 11px 11px;
    border-radius: 4px;
    border: solid 1px #c8cfd7;
    background-color: #004e88;
    font-size: 12px;
    color: #fff;
    font-weight: bold;
  }
}
</style>
